import type WaRadioGroup from "@awesome.me/webawesome/dist/components/radio-group/radio-group.js";
import { repairBodyOf } from "../content/lianxi/yufa-repair.js";
import { repairAnswer } from "../fuxi/yufa-repair-answer.js";
import type { RepairAnswer } from "../fuxi/yufa-marking.js";
import { teachingOn } from "./lianxi-yufa-teaching.js";

/** An unset location remains unanswered, including when a correction has been typed. */
export function readRepair(form: HTMLFormElement): RepairAnswer | undefined {
  const group = form.querySelector<WaRadioGroup>("[data-cb-yufa-repair]");
  const value = group?.value;
  const body = repairBodyOf(
    JSON.parse(group?.dataset["cbYufaRepair"] ?? "null") as unknown,
  );
  if (
    body === undefined ||
    value === undefined ||
    value === null ||
    value === ""
  ) {
    return undefined;
  }
  const teaching = teachingOn(form);
  return repairAnswer(
    { ...body, ...(teaching === undefined ? {} : { teaching }) },
    Number(value),
    form.querySelector<HTMLInputElement>("[data-cb-yufa-typed]")?.value ?? "",
  );
}

/** No-change answers use the original sentence and need no typed correction. */
export function updateRepairInput(form: HTMLFormElement): void {
  const group = form.querySelector<WaRadioGroup>("[data-cb-yufa-repair]");
  const input = form.querySelector<HTMLInputElement>("[data-cb-yufa-typed]");
  if (group !== null && input !== null) {
    input.disabled =
      group.value ===
      group.querySelector("[data-cb-yufa-no-change]")?.getAttribute("value");
  }
}
